import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { setAxiosAuth } from 'utils';
import { commonApi } from 'core/api/common.api';

export const useGetPrtnerInfo = ({ accessToken = '' }) => {
  setAxiosAuth(accessToken);

  return useQuery({
    queryKey: [queryKeys.partnerInfo],
    queryFn: commonApi.getPartnerInfo,
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(accessToken),
  });
}
